import * as z from "zod/v4";

export enum ConvertFedexTokenError {
  ExpiredToken = "ExpiredToken",
  InvalidToken = "InvalidToken",
}

export const convertFedexTokenToCustomerAuth = {
  name: "convertFedexTokenToCustomerAuth" as const,
  input: z.object({ fedexEasyReturnsLocationsToken: z.string() }),
  output: z.object({ customerAuthToken: z.string(), returnId: z.string() }),
};
